var _rect, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#686982",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#38a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CACAD5",
    d: "m14.852 32.069 2.667 1.281.777.376-4.091-17.931h-3.068zm-6.9-3.328 3.457 1.658-3.34-14.604H5zm14.319-4.518-1.93-8.428h-3.068l3.457 15.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B9BAB",
    d: "m25.909 31.628-2.991 1.438L28.64 8l2.072 2.59zm5.981-2.887-2.99 1.437 3.883-16.985 2.072 2.602zM13.286 5.411l-2.072 2.59H23.32l-.595 2.59H9.143L7.07 13.204h15.057l-.595 2.59H5l.596 2.59H20.95L17.52 33.35l2.394 1.152 6.655-29.09z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "38a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h30v30H5z"
  })))));
});
const SvgCin7Disabled = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCin7Disabled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiM2ODY5ODIiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0MzBfMzUzOTUpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC44NTIzIDMyLjA2ODdMMTcuNTE5MyAzMy4zNTA1TDE4LjI5NjEgMzMuNzI1OUwxNC4yMDUgMTUuNzk0OUgxMS4xMzY3TDE0Ljg1MjMgMzIuMDY4N1pNNy45NTE4MSAyOC43NDE1TDExLjQwODUgMzAuMzk4Nkw4LjA2ODMzIDE1Ljc5NDlINUw3Ljk1MTgxIDI4Ljc0MTVaTTIyLjI3MDcgMjQuMjIzMUwyMC4zNDE3IDE1Ljc5NDlIMTcuMjczM0wyMC43MzAxIDMwLjk0MjRMMjIuMjcwNyAyNC4yMjMxWiIgZmlsbD0iI0NBQ0FENSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI1LjkwODcgMzEuNjI4NEwyMi45MTggMzMuMDY1NUwyOC42NDA0IDguMDAwOTNMMzAuNzExOSAxMC41OTAyTDI1LjkwODcgMzEuNjI4NFpNMzEuODkgMjguNzQxM0wyOC44OTkzIDMwLjE3ODRMMzIuNzgzMyAxMy4xOTI1TDM0Ljg1NDggMTUuNzk0OEwzMS44OSAyOC43NDEzWk0xMy4yODU4IDUuNDExNjJMMTEuMjE0MyA4LjAwMDkzSDIzLjMxOTRMMjIuNzIzOCAxMC41OTAySDkuMTQyOUw3LjA3MTQ1IDEzLjIwNTRIMjIuMTI4M0wyMS41MzI4IDE1Ljc5NDhINUw1LjU5NTU0IDE4LjM4NDFIMjAuOTUwMkwxNy41MTkzIDMzLjM1MDNMMTkuOTE0NCAzNC41MDI1TDI2LjU2OSA1LjQxMTYySDEzLjI4NThaIiBmaWxsPSIjOUI5QkFCIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTQzMF8zNTM5NSI+CjxyZWN0IHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUgNSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";